import { Capacitor } from "@capacitor/core";
import { FirebaseCrashlytics } from "@capacitor-firebase/crashlytics";

export async function initializeCrashReporting() {
  if (!Capacitor.isNativePlatform()) return;
  await FirebaseCrashlytics.setUserId({ userId: "" }).catch(() => undefined);
  await FirebaseCrashlytics.setCustomKey({
    key: "surface",
    value: Capacitor.getPlatform(),
    type: "string",
  }).catch(() => undefined);
  await FirebaseCrashlytics.setEnabled({ enabled: true }).catch(() => undefined);
}

export function recordNativeException(reason: unknown) {
  if (!Capacitor.isNativePlatform()) return;
  const error = reason instanceof Error ? reason : new Error("Unhandled app error");
  void FirebaseCrashlytics.recordException({
    message: error.message.slice(0, 500),
    keysAndValues: [
      {
        key: "has_js_stack",
        value: Boolean(error.stack),
        type: "boolean",
      },
    ],
  }).catch(() => undefined);
}
